module.exports = __webpack_public_path__ + "static/img/rider.0585a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rider.png
// module id = CFob
// module chunks = 2